import {getBiToken, getInstanceId, getRandomGuid4, getVisitorId} from '@wix/music-shared/dist/src/utils/wix-utils';
import {biLogger} from '../statistics/_loggers';
import {isBlacklisted} from '../utils/isBlacklisted';

export function initPreOpened() {
  if (isBlacklisted()) {
    return;
  }

  const params = {
    endpoint: 'music-ugc',
    src: 9,
    albumID: getRandomGuid4(),
    playerInstanceID: getInstanceId(),
    sid: getBiToken(),
    visitorId: getVisitorId(),
  };

  biLogger.log({
    src: 9,
    evid: 188,
    albumID: getRandomGuid4(),
  });

  window.addEventListener('unload', () => {
    biLogger.log({
      src: 9,
      evid: 206,
    });
    return;
  });
}
